import React, { useState } from "react";
import "./components/styles/reset.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ChatApp from "./components/ChatApp";
import LoginForm from "./components/Login/login";
import Folderupload from "../src/components/upload/NewUpload";
import ComparePDF from "./pages/compare/ComparePDF";
import Cluster from "./pages/cluster/Cluster";
import HomePage from "./pages/home/HomePage";
import Summarize from "./pages/summarize/Summarize";
import AppContextProvider from "./AppContext";
import SummaryDetails from "./pages/summarize/SummaryDetails";
import SimilarDocuments from "./pages/similarDocuments/SimilarDocuments";
import SimilarityDetails from "./pages/similarDocuments/SimilarityDetails";
import Compare from "./pages/compare/Compare";
import CompareDetails from "./pages/compare/CompareDetails";
import ClusterDetails from "./pages/cluster/ClusterDetails";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState(sessionStorage.getItem("userName"));
  const [collapse, setCollapse] = useState(false);

  if (!isLoggedIn) {
    let accessToken = sessionStorage.getItem("accesstoken");
    console.log("accessToken:", accessToken);
    if (accessToken) {
      setIsLoggedIn(true);
    }
  }

  let routes = isLoggedIn ? (
    <>
      <Route path="/" element={<HomePage setIsLoggedIn={setIsLoggedIn} />} />
      <Route
        path="/overview"
        element={
          <Folderupload setIsLoggedIn={setIsLoggedIn} userName={userName} />
        }
      />
      <Route path="*" element={<Navigate to="/" />} />
      <Route path="/chat" element={<ChatApp setIsLoggedIn={setIsLoggedIn} />} />
      <Route path="/compare" element={<Compare />} userName={userName} />
      <Route
        path="/compare/:id"
        element={<CompareDetails />}
        userName={userName}
      />
      <Route path="/cluster" element={<Cluster />} userName={userName} />
      <Route path="/cluster/:id" element={<ClusterDetails />} />
      <Route path="/summarize" element={<Summarize />} userName={userName} />
      <Route
        path="/summarize/:id"
        element={<SummaryDetails />}
        userName={userName}
      />
      <Route
        path="/similarity"
        element={<SimilarDocuments />}
        userName={userName}
      />
      <Route
        path="/similarity/:id"
        element={<SimilarityDetails />}
        userName={userName}
      />
    </>
  ) : (
    <>
      <Route
        index
        element={
          <LoginForm setIsLoggedIn={setIsLoggedIn} setUserName={setUserName} />
        }
      />
      <Route path="*" element={<Navigate to="/" />} />
    </>
  );

  return (
    <div className="App">
      <AppContextProvider
        value={{
          userName,
          isLoggedIn,
          collapse,
          setCollapse,
        }}
      >
        <BrowserRouter>
          <Routes>{routes}</Routes>
        </BrowserRouter>
      </AppContextProvider>
    </div>
  );
}

export default App;
